/* fs-header.js — everything the header bar needs that markup alone cannot give it.

   FOUR JOBS:
     1. a down-arrow pill next to every parent item, as a real <button>
     2. proportional widths, so slack is shared the way the reference shares it
     3. .fs-nav-current on the section the visitor is actually in
     4. the SEARCH and CART (n) segments at the right

   WHY THE SEGMENTS FORWARD A CLICK RATHER THAN JUST LINKING
   The theme's search and cart are icons, and fs-header.css hides both on
   desktop. A segment with href="/cart" silently replaced the POP-UP CART DRAWER
   with the full cart page — Ezra spotted it immediately ("you changed our pop up
   cart. do not do that"). href="/search" would do the same to search. So each
   segment forwards its click to the theme's own hidden control, which is why
   those controls are hidden in CSS rather than removed: hidden elements still
   respond to .click(). The hrefs stay as a no-JS fallback.

   SEARCH REPLACED LOG IN on 2026-08-30, on 90 days of store data: these
   segments are desktop-only and desktop is 33% of 20,018 sessions; the store is
   on passwordless customer accounts, so returning buyers (32% of 115 orders)
   reach their orders from the confirmation email; and desktop had NO search at
   all. Account access moved to the footer menu.

   The toggle is a child of the <li>, NEVER a new <li>. fs-menu-click.js maps an
   open menu by its index within .navigation__tier-1, so adding a list item here
   would silently open the wrong panel.

   The .fs-navboxed class on <html> gates every rule in fs-header.css, so if this
   script fails the header simply stays as the theme drew it.

   NOTE ON THE HIDDEN SECOND NAV: this file decorates BOTH desktop copies (see
   init). That is still right — but the comment that used to say the hidden copy
   "costs nothing" was wrong: its toggles scrolled every page sideways by 22px.
   assets/fs-overflow.css contains the fix and the full explanation. */
(function () {
  var root = document.documentElement;
  var LISTS = '.navigation--left .navigation__tier-1,' +
              ' main-navigation .navigation--main .navigation__tier-1';

  /* Digits without a regex escape. `/\\d+/` written through the theme file API
     has arrived as a DOUBLE backslash more than once in this theme, matching a
     literal backslash and silently never firing — see the header of
     fs-sticky.js. Cheap to avoid, expensive to debug. */
  function firstNumber(str) {
    var out = '';
    var i, code;
    for (i = 0; i < str.length; i++) {
      code = str.charCodeAt(i);
      if (code >= 48 && code <= 57) out += str.charAt(i);
      else if (out) break;
    }
    return out ? parseInt(out, 10) : 0;
  }

  /* ⚠ READ THE THEME'S COUNT NODE, NEVER .cart-link's WHOLE TEXT.
     BUG FIXED 2026-09-06, found in the pre-launch audit. This used to read
     `.cart-link`'s textContent and take the first number in it. That worked
     until the mobile cart pill shipped: fs-mobilebar.js mirrors THIS segment's
     label into `.cart-link__label`, so the anchor's text became

         "Cart (0)\n2"        <- our label, then the theme's real count

     and the first number in it is the ZERO WE WROTE. The count then fed itself:
     whatever the page loaded with became permanent, and adding to cart moved
     the drawer and the theme's own badge while the nav bar sat on "Cart (0)"
     forever. Verified on a PDP with two items actually in /cart.js.

     `.cart-link__count` is the theme's own badge and nothing of ours writes to
     it. It lives INSIDE `.cart-link__icon`, which fs-mobilebar.css hides on
     mobile — that only stops it painting, the text is still readable here.

     The fallback still parses the anchor, for any template where the badge is
     absent, but it strips our own label first so it cannot re-poison itself. */
  function cartCount() {
    var badge = document.querySelector('.cart-link__count');
    if (badge) return firstNumber(badge.textContent || '');

    var link = document.querySelector('.cart-link');
    if (!link) return 0;
    var text = link.textContent || '';
    var label = link.querySelector('.cart-link__label');
    if (label && label.textContent) {
      var at = text.indexOf(label.textContent);
      if (at > -1) text = text.slice(0, at) + text.slice(at + label.textContent.length);
    }
    return firstNumber(text);
  }

  function makeSegment(label, href, cls) {
    var li = document.createElement('li');
    li.className = 'navigation__item fs-nav-action' + (cls ? ' ' + cls : '');
    var a = document.createElement('a');
    a.className = 'navigation__link';
    a.href = href;
    a.textContent = label;
    li.appendChild(a);
    return li;
  }

  /* Send the click to one of the theme's own controls instead of navigating.
     Modified and middle clicks keep the href so "open in new tab" still works. */
  function forwardTo(anchor, selector) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(selector);
      if (!target || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      target.click();
    });
  }

  /* --- 1. the down-arrow pill -------------------------------------------
     One per parent item, appended INSIDE the <li> after the label link.
     fs-menu-click.js listens for it in the capture phase; this file only
     builds it, so the two cannot disagree about what a click means. */
  function addToggle(li) {
    if (li.querySelector('.fs-nav-toggle')) return;
    var link = li.querySelector('.navigation__link');
    if (!link) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fs-nav-toggle';
    b.setAttribute('aria-expanded', 'false');
    b.setAttribute('aria-label', 'Open the ' + (link.textContent || '').trim() + ' menu');
    var g = document.createElement('span');
    g.className = 'fs-nav-toggle__glyph';
    g.setAttribute('aria-hidden', 'true');
    g.textContent = '↓';
    b.appendChild(g);
    li.appendChild(b);
  }

  /* --- 2. proportional widths -------------------------------------------
     The reference does NOT split slack equally: measured across its five pills,
     width/content held at 2.2 ± 0.2, i.e. each pill grows in proportion to its
     own label. flex-grow set to the label's character count reproduces that,
     and flex-basis stays auto (in the CSS) so nothing is ever crushed below its
     own text. Actions are pinned to their content by the stylesheet. */
  function setGrow(li) {
    var link = li.querySelector('.navigation__link');
    if (!link) return;
    var n = (link.textContent || '').trim().length;
    li.style.flexGrow = String(n > 0 ? n : 1);
  }

  /* --- 3. the current section -------------------------------------------
     Segment-aware prefix match, never a bare startsWith: /pages/events must not
     light up on /pages/events-2026. An exact match wins outright, so a deeper
     page (a product under /collections/shop-all) still marks its section.
     Links whose href is "#" or empty can never match, which is correct. */
  function markCurrent(list) {
    var here = window.location.pathname.replace(/\/+$/, '') || '/';
    var best = null, bestLen = -1;
    Array.prototype.forEach.call(list.children, function (li) {
      li.classList.remove('fs-nav-current');
      if (li.classList.contains('fs-nav-action')) return;
      var a = li.querySelector('.navigation__link');
      if (!a || !a.getAttribute('href')) return;
      var p;
      try { p = new URL(a.href, window.location.origin).pathname; } catch (err) { return; }
      p = p.replace(/\/+$/, '');
      if (!p || p === '/') return;
      if (here === p || here.indexOf(p + '/') === 0) {
        if (p.length > bestLen) { bestLen = p.length; best = li; }
      }
    });
    if (best) best.classList.add('fs-nav-current');
  }

  /* --- 4. keeping CART (n) honest ---------------------------------------
     BUG FIXED 2026-09-04. The first version of this observed .cart-link itself.
     The theme does not MUTATE that anchor when the cart changes — it REPLACES
     it. Proved by tagging the node: after an add, marked.isConnected === false
     and document.querySelector('.cart-link') is a different element. So the
     observer sat on a detached node and the segment kept whatever the page
     loaded with.

     Two independent triggers, because each alone has a failure mode:
       - the theme's own cart events, which bubble to document: on:cart:add and
         on:cart:after-merge were observed firing on PRODUCT-FORM and CART-FORM
         respectively; :change and :error are the theme's other two. Survives any
         reshaping of the header markup.
       - a MutationObserver on the header's .shopify-section wrapper. The
         Section Rendering API replaces what is INSIDE that wrapper, never the
         wrapper itself, so this one cannot go stale the way the old one did.
         Covers any path that updates the count without dispatching an event.
     Both funnel into one idempotent write. The segments are re-queried on every
     sync so a replaced one is picked up too, and the write is skipped when the
     text already matches. The read is deferred: the event fires before the theme
     has rewritten .cart-link, so we sync on the next task AND again at 300ms.
     Plain setTimeout, not requestAnimationFrame — rAF is frozen in a background
     tab, which is exactly where a slow add-to-cart lands.

     ⚠ The 2026-09-04 wiring was correct and still never updated on mobile,
     because the READ was broken rather than the trigger — see cartCount(). If
     this ever goes stale again, log cartCount() before assuming the events
     stopped firing. */
  function syncCartLabels() {
    var label = 'Cart (' + cartCount() + ')';
    var labels = document.querySelectorAll('.fs-nav-action--cart .navigation__link');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent !== label) labels[i].textContent = label;
    }
  }

  var syncPending = false;
  function scheduleCartSync() {
    if (!syncPending) {
      syncPending = true;
      setTimeout(function () { syncPending = false; syncCartLabels(); }, 0);
    }
    setTimeout(syncCartLabels, 300);
    /* The theme rewrites .cart-link after its own event; 900ms covers a slow
       Section Rendering round trip on a phone. Idempotent, so a third pass is
       free. */
    setTimeout(syncCartLabels, 900);
  }

  function watchCart() {
    ['on:cart:add', 'on:cart:change', 'on:cart:error', 'on:cart:after-merge']
      .forEach(function (name) { document.addEventListener(name, scheduleCartSync); });
    /* bfcache restore: Safari's back button serves a page whose cart may have
       moved on since it was frozen. */
    window.addEventListener('pageshow', scheduleCartSync);

    var link = document.querySelector('.cart-link');
    var host = link && link.closest ? link.closest('.shopify-section') : null;
    if (host && window.MutationObserver) {
      new MutationObserver(scheduleCartSync)
        .observe(host, { childList: true, subtree: true, characterData: true });
    }
  }

  function init() {
    /* Both desktop copies get everything, because the theme swaps which one is
       live by width and we cannot predict the choice. The mobile drawer's
       .navigation--main is excluded by the `main-navigation` ancestor. */
    var lists = document.querySelectorAll(LISTS);
    if (!lists.length) return;

    root.classList.add('fs-navboxed');

    var madeSegments = false;

    Array.prototype.forEach.call(lists, function (list) {
      Array.prototype.forEach.call(list.children, function (li) {
        if (li.classList.contains('navigation__item--with-children')) addToggle(li);
        setGrow(li);
      });

      if (!list.querySelector('.fs-nav-action')) {
        var searchSeg = makeSegment('Search', '/search', 'fs-nav-action--search');
        list.appendChild(searchSeg);
        forwardTo(searchSeg.querySelector('.navigation__link'), '.show-search-link');

        var cartSeg = makeSegment('Cart (' + cartCount() + ')', '/cart', 'fs-nav-action--cart');
        list.appendChild(cartSeg);
        forwardTo(cartSeg.querySelector('.navigation__link'), '.cart-link');
        madeSegments = true;
      }

      markCurrent(list);
    });

    if (!madeSegments) return;
    syncCartLabels();
    watchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();